/*  */
import BoxBody from 'components/BoxBody';
import Button from 'components/ButtonDeprecated';
import ConfirmDialog from 'components/ConfirmDialog';
import Dialog from 'components/Dialog';
import Field from 'components/Field';
import FormNote from 'components/FormNote';
import Input from 'components/Input';
import Label from 'components/Label';
import ModalTrigger from 'components/ModalTrigger';
import * as React from 'react';
import RelationshipActions from 'actions/RelationshipActions';
import Subscriber from 'entities/Subscriber';

class ChangeUntrustedNameModal extends React.Component<
  {
    subscriber: Subscriber;
    onCancel?: Function | null;
    onRequestHide: Function;
  },
  any
> {
  state = {
    firstName: this.props.subscriber.getFirstName(),
    lastName: this.props.subscriber.getLastName(),
  };

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  cancelConfirmDialog = (event) => {
    event.preventDefault();
    if (this.props.onCancel) {
      this.props.onCancel();
    }
    this.props.onRequestHide();
  };

  // change
  changeName = () => {
    const subscriberId = this.props.subscriber.id;
    const { firstName, lastName } = this.state;
    RelationshipActions.updateName(subscriberId, firstName, lastName);
    this.props.onRequestHide();
  };

  closeUntrustedNameModal = () => {
    this.props.onRequestHide();
  };

  renderConfirmDialog = () => {
    const confirmString =
      'Are you sure you want to change this participant’s name to ' +
      this.state.firstName +
      ' ' +
      this.state.lastName +
      '?';
    return (
      <ConfirmDialog
        eventScreenName="ChangeUntrustedNameModal"
        title={confirmString}
        onConfirm={this.changeName}
      >
        A participant’s name can only be changed once.
      </ConfirmDialog>
    );
  };

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  handleFirstNameChange = (event) => {
    this.setState({
      firstName: event.target.value,
    });
  };

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  handleLastNameChange = (event) => {
    this.setState({
      lastName: event.target.value,
    });
  };

  render() {
    const confirmDialog = this.renderConfirmDialog();
    return (
      <Dialog
        {...this.props}
        className="ChangeUntrustedNameModal"
        title="Change name"
        size="xxsmall"
        onRequestHide={this.closeUntrustedNameModal}
      >
        <BoxBody>
          <form>
            <Field>
              <Label>First name</Label>
              <Input value={this.state.firstName} onChange={this.handleFirstNameChange} />
            </Field>
            <Field>
              <Label>Last name</Label>
              <Input value={this.state.lastName} onChange={this.handleLastNameChange} />
            </Field>
            <FormNote glyph="caution" glyphColor="apple">
              You can only change this once.
            </FormNote>
            <ModalTrigger modal={confirmDialog}>
              <Button>Change</Button>
            </ModalTrigger>
          </form>
        </BoxBody>
      </Dialog>
    );
  }
}

export default ChangeUntrustedNameModal;
